import { PARSE_URL_PARAMETERS, ADD_URL_PARAMETERS_FROM_COOKIE_HISTORY } from '../constants';
import { getQueryParams } from '../core/util/url';

function parseUrlParameters(value) {
  return {
    type: PARSE_URL_PARAMETERS,
    payload: { value: getQueryParams(value) },
  };
}

function addUrlParametersFromCookieHistory(value) {
  return {
    type: ADD_URL_PARAMETERS_FROM_COOKIE_HISTORY,
    payload: { value },
  };
}

export { parseUrlParameters, addUrlParametersFromCookieHistory };
